__turbopack_context__.v({
  "actions": "page-module-scss-module__F3qyTW__actions",
  "checkbox": "page-module-scss-module__F3qyTW__checkbox",
  "checkboxContainer": "page-module-scss-module__F3qyTW__checkboxContainer",
  "contactDescription": "page-module-scss-module__F3qyTW__contactDescription",
  "deliveryOptions": "page-module-scss-module__F3qyTW__deliveryOptions",
  "emailFieldWrapper": "page-module-scss-module__F3qyTW__emailFieldWrapper",
  "emailRegisteredBanner": "page-module-scss-module__F3qyTW__emailRegisteredBanner",
  "embedded": "page-module-scss-module__F3qyTW__embedded",
  "error": "page-module-scss-module__F3qyTW__error",
  "field": "page-module-scss-module__F3qyTW__field",
  "form": "page-module-scss-module__F3qyTW__form",
  "formSection": "page-module-scss-module__F3qyTW__formSection",
  "label": "page-module-scss-module__F3qyTW__label",
  "mandatoryNote": "page-module-scss-module__F3qyTW__mandatoryNote",
  "page": "page-module-scss-module__F3qyTW__page",
  "pageHeading": "page-module-scss-module__F3qyTW__pageHeading",
  "required": "page-module-scss-module__F3qyTW__required",
  "row": "page-module-scss-module__F3qyTW__row",
  "saveAddressAction": "page-module-scss-module__F3qyTW__saveAddressAction",
  "saveAddressButton": "page-module-scss-module__F3qyTW__saveAddressButton",
  "section": "page-module-scss-module__F3qyTW__section",
  "sectionLoadingFrame": "page-module-scss-module__F3qyTW__sectionLoadingFrame",
  "sectionTitle": "page-module-scss-module__F3qyTW__sectionTitle",
  "serverErrors": "page-module-scss-module__F3qyTW__serverErrors",
  "summarySection": "page-module-scss-module__F3qyTW__summarySection",
});
